(function (jQuery) {
    if (window.user_id && parseInt(scriptParams.CurrentPersonId) > 0 ) {
        var timer = 120, minutes, seconds;
        var showPopUp = (time_setting - timer)*1000;
        const logout_time = time_setting * 1000;
        
        jQuery(document).ready(function () {
            var timerInterval = 0;
            var popup = setTimeout(() => {
                startTimer();
            }, showPopUp);

            var logout = setTimeout(() => {
                const para = document.createElement("a");
                para.href = logout_url;
                para.click()

            }, logout_time);

            document.onclick = function () {
                var logoutBox = document.getElementById("Logout-Box");
                if (logoutBox) {
                }
                else {
                    clearTimeout(logout);
                    clearTimeout(popup);
                    
                    logout = setTimeout(() => {
                        const para = document.createElement("a");
                        para.href = logout_url;
                        para.click()
                    }, logout_time);

                    popup = setTimeout(() => {
                        startTimer();
                    }, showPopUp)
                }
            }
            function startTimer() {
                timer = 120, minutes, seconds;
                var displayIdleTimeoutMsg = "<div class='timerMsg'>Your session will expire in <span id='LogoutTimer'></span> seconds</div>" + "<div>" + idle_msg + "</div>";
                if(timerInterval !== 0) {
                    clearInterval(timerInterval);
                }
                timerInterval = setInterval(function () {
                    minutes = parseInt(timer / 60, 10)
                    seconds = parseInt(timer % 60, 10);

                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;
                    jQuery('.timerMsg #LogoutTimer').text(minutes + " minutes and " + seconds)
                    
                    if(--timer < 0) {
                        timer = 0;
                    }

                }, 1000);
                var button = "<button onclick='sm.portal.ui.removeLightbox()'>Continue</button> <button onclick='location.replace(logout_url)'>Logout</button>";
                sm.portal.ui.lightBoxLogout("Session Timeout", displayIdleTimeoutMsg, 'smallDialog', null, null, button, null);
            }
        });
    }
}(jQuery));